import members from "./members";

export const descendants = {
    members,
};

export default descendants;
